import { IconProps } from "./types";

export const Coupon = ({ fill = "rgba(255, 255, 255, 0.6)", size = 18, style }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" style={style}>
    <path
      d="M12.806 5.16667V5.175M7.46432 16.4917L1.48932 10.5167C1.33436 10.3619 1.21143 10.1781 1.12756 9.97573C1.04368 9.7734 1.00051 9.55653 1.00051 9.3375C1.00051 9.11847 1.04368 8.9016 1.12756 8.69927C1.21143 8.49694 1.33436 8.31312 1.48932 8.15833L8.63932 1H16.9727V9.33333L9.81432 16.4917C9.50205 16.8021 9.07963 16.9763 8.63932 16.9763C8.19901 16.9763 7.77659 16.8021 7.46432 16.4917Z"
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
